import styles from './thoughtchain.module.scss'

export default function SourcePills({ labels = [] }) {
  if (!labels.length) return null
  return (
    <div className={styles.pillRow}>
      {labels.map((label) => (
        <span key={label} className={styles.pill}>
          {label}
        </span>
      ))}
    </div>
  )
}
